/**
 * useOrderLock — acquire on mount, release on unmount, heartbeat 5min.
 * JA: lock pessimístico obrigatório (1 user por ordem).
 */
import { useState, useEffect } from 'react';
import api from '../services/api.js';

export function useOrderLock(orderId, { enabled = true } = {}) {
  const [lock, setLock] = useState({ loading: enabled, locked: false, isMine: false, holder: null });

  useEffect(() => {
    if (!enabled || !orderId) {
      setLock({ loading: false, locked: false, isMine: false, holder: null });
      return;
    }

    let cancelled = false;
    let heartbeatTimer = null;

    (async () => {
      try {
        const r = await api.post(`/orders/${orderId}/lock`);
        if (cancelled) return;
        const isMine = !!r.data.isMine;
        setLock({ loading: false, locked: true, isMine, holder: r.data.holder });

        if (isMine) {
          // Heartbeat a cada 5 min
          heartbeatTimer = setInterval(async () => {
            try { await api.post(`/orders/${orderId}/lock/heartbeat`); }
            catch (_) { /* token expirou ou lock perdido */ }
          }, 5 * 60 * 1000);
        }
      } catch (e) {
        if (cancelled) return;
        const holder = e.response?.data?.holder || null;
        setLock({ loading: false, locked: true, isMine: false, holder });
      }
    })();

    // Release on unmount apenas se for o holder
    return () => {
      cancelled = true;
      if (heartbeatTimer) clearInterval(heartbeatTimer);
      api.post(`/orders/${orderId}/unlock`).catch(() => {});
    };
  }, [orderId, enabled]);

  const forceRelease = async (reason) => {
    await api.post(`/orders/${orderId}/lock/force-release`, { reason });
    setLock({ loading: false, locked: false, isMine: false, holder: null });
  };

  return { ...lock, forceRelease };
}

export default useOrderLock;
